const init = () => {
    const desktopMediaQuery = window.matchMedia('(min-width: 1025px)');
    let areDropdownsOpen = false;

    const selects = document.querySelectorAll('.custom-select select');
    const customSelectTogglers = document.querySelectorAll('.custom-select__value');
    const customSelectOptions = document.querySelectorAll('.new-dropdown__list-item');
    const updateSelect = (select) => {
        try {
            select.closest('.custom-select').querySelector('.custom-select__value').textContent = select.options[select.selectedIndex].text;
        } catch (e) {
            console.warn(e);
        }
    };
    selects.forEach((select) => {
        updateSelect(select);
        select.addEventListener('change', () => {
            updateSelect(select);
        });
    });

    const initStyledDropdowns = () => {
        const isDesktop = desktopMediaQuery.matches;

        const closeAllDropdowns = () => {
            const dropdowns = document.querySelectorAll('.new-dropdown__list');
            dropdowns.forEach((drop) => {
                const isHtmlControlled = drop.closest('.custom-select').classList.contains('custom-select--html-controled');
                if (!isHtmlControlled) {
                    drop.classList.remove('new-dropdown__list--show');
                    drop.setAttribute('aria-hidden', true);
                }
            });
            areDropdownsOpen = false;
        };

        const onClickOutside = (e) => {
            if (
                e.target.closest('.new-dropdown__list') !== null ||
                e.target.closest('.custom-select__value') !== null
            ) {
                return;
            }
            closeAllDropdowns();
        }
        document.removeEventListener('click', onClickOutside);
        document.addEventListener('click', onClickOutside);

        const onScroll = () => {
            if (areDropdownsOpen) {
                closeAllDropdowns();
            }
        }
        window.removeEventListener('scroll', onScroll);
        window.addEventListener('scroll', onScroll, { passive: true });

        customSelectTogglers.forEach((toggler) => {
            const wrap = toggler.closest('.custom-select');

            if (!isDesktop && !wrap.classList.contains('enable-custom-mobile')) {
                return;
            }

            const onTogglerClick = (e) => {
                e.preventDefault();
                e.stopPropagation();

                const dropdown = toggler.parentElement.querySelector('.new-dropdown__list');
                if (!dropdown.classList.contains('new-dropdown__list--show')) {
                    closeAllDropdowns();
                    areDropdownsOpen = true;
                    dropdown.removeAttribute('aria-hidden');                    
                }
                dropdown.classList.toggle('new-dropdown__list--show');
            };
            toggler.removeEventListener('click', onTogglerClick);
            toggler.addEventListener('click', onTogglerClick);
        });
        customSelectOptions.forEach((liOption) => {
            const wrap = liOption.closest('.custom-select');
            if (!isDesktop && !wrap.classList.contains('enable-custom-mobile')) {
                return;
            }
            const currOption = liOption.querySelector('.new-dropdown__link');
            if (currOption === null || !currOption.dataset.value) {
                return;
            }
            const onLiClick = (e) => {
                e.preventDefault();
                e.stopPropagation();
                const option = liOption.querySelector('.new-dropdown__link');

                const realSelect = option.closest('.new-dropdown__list').parentElement.querySelector('select');
                realSelect.value = option.dataset.value;
                realSelect.dispatchEvent(new Event('change'));

                const currentOption = option.parentElement;
                const currentHtml = option.parentElement.innerHTML;
                const firstElement = currentOption.parentElement.querySelector('.new-dropdown__list-item');
                const firstElementHtml = firstElement.innerHTML;
                firstElement.innerHTML = currentHtml;
                currentOption.innerHTML = firstElementHtml;
                closeAllDropdowns();
            };
            liOption.removeEventListener('click', onLiClick);
            liOption.addEventListener('click', onLiClick);
        });
    }
    initStyledDropdowns();

    desktopMediaQuery.onchange = () => {
        initStyledDropdowns();
    }
}

export default init;